import { DEV } from "solid-js"
import { freeze } from "../util/Object"

const dijkstraDirectionCharsUpperCase = [
  'S',
  'E',
  'N',
  'W',
] as const

if (DEV) {
  freeze(dijkstraDirectionCharsUpperCase)
}

export default dijkstraDirectionCharsUpperCase